import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { oneWay } from '@ember/object/computed';
import Route from 'cio/routes/base';
import DS from 'ember-data';
import SegmentController from 'cio/pods/segments/segment/controller';
import SegmentModel from 'cio/models/segment';
import Transition from '@ember/routing/-private/transition';

export default class SegmentRoute extends Route {
  @service store!: DS.Store;

  crumb() {
    let model = this.modelFor('segments.segment');

    return {
      name: oneWay('model.name'),
      path: 'segments.segment',
      model,
    };
  }

  model(params: { segment_id: string }) {
    return this.store.findRecord('segment', params.segment_id);
  }

  setupController(controller: SegmentController, model: SegmentModel, transition: Transition) {
    super.setupController(controller, model, transition);

    // Poll for imports only for manual segments
    if (model.isManual) {
      controller.fetchAndPollForImports.perform();
    }

    controller.fetchPeopleCount.perform();

    if (model.isBuilding) {
      controller.pollForBuildFinish.perform();
    }
  }

  resetController(controller: SegmentController, isExiting: boolean, transition: Transition) {
    super.resetController(controller, isExiting, transition);

    if (isExiting) {
      controller.fetchAndPollForImports.cancelAll();
      controller.pollForBuildFinish.cancelAll();
    }
  }

  @action
  refreshModel() {
    return this.refresh();
  }
}
